import React, { FC } from 'react';
import { Text } from '@src/atoms/Text';
import { IComponentChildrenProps } from '@src/models/props';
import styles from '../_OfferLink/FeedbackFormOfferLink.scss';

interface IProps extends IComponentChildrenProps {
  href: string;
  target?: string;
  id: string;
}

export const FeedbackFormMarketingCheckboxLink: FC<IProps> = ({ id, href, target, children }) => {
  return (
    <Text id={`${id}_text`} size="secondary" className={styles.root}>
      Хочу получать&nbsp;
      <a href={href} target={target} rel="noopener noreferrer">
        {children}
      </a>&nbsp;от Centra
    </Text>
  );
};
